import {configureStore} from '@reduxjs/toolkit'

import userSlice from "./user/userSlice"
import dashboardSlice from './dashboard/dashboardSlice'
import applicationSlice from './application/applicationSlice'

const store = configureStore({
    reducer: {
        user: userSlice,
        dashboard: dashboardSlice,
        application: applicationSlice,
    }
})

// Can still subscribe to the store
//store.subscribe(() => console.log(store.getState()))
export default store
